import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderToday: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="calender-today"><path fillRule="evenodd" clipRule="evenodd" d="M3 4.75C3 3.7835 3.7835 3 4.75 3H19.25C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75ZM19.5 8H4.5V19.25C4.5 19.3881 4.61193 19.5 4.75 19.5H19.25C19.3881 19.5 19.5 19.3881 19.5 19.25V8ZM9.5 13.75C9.5 12.3693 10.6193 11.25 12 11.25C13.3807 11.25 14.5 12.3693 14.5 13.75C14.5 15.1307 13.3807 16.25 12 16.25C10.6193 16.25 9.5 15.1307 9.5 13.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCalenderToday;
